import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { fussbad, gold, green, welcome } from "../utils"; // replace with your actual image import

gsap.registerPlugin(ScrollTrigger);

const Highlights = () => {
  useEffect(() => {
    // Example GSAP or ScrollTrigger code here if desired
  }, []);

  return (
    <div>
      <div className="w-full bg-white text-gray-900 py-16 lg:py-40">
        <div className="max-w-7xl mx-auto px-8 flex flex-col-reverse md:flex-row items-center gap-16">
          {/* Left Section */}
          <div className="flex-1">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Willkommen zum Oase Salon
            </h1>
            <p className="text-lg md:text-xl mb-4 lg:mb-8 leading-relaxed">
              Erleben Sie ultimative Entspannung und Verjüngung in unserem
              Massage-Wellness-Spa; das eine Vielzahl von Dienstleistungen wie
              Massagen, Maniküre, Pediküre und Gesichtsbehandlungen für Ihre
              Schönheitsbedürfnisse anbietet.
            </p>
            <a
              href="https://www.treatwell.at/ort/oase-salon-massage-kosmetik-fusspflege/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="px-[36%] py-[.5rem] lg:px-[.9rem] lg:py-[.5rem] text-white text-lg font-medium 
                    bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-500 
                    transition-all duration-300 shadow-lg shadow-green-400/30 hover:shadow-green-700/100
                    rounded-xl"
              >
                <p className="text-2md lg:text-2xl sm:text-md whitespace-nowrap">
                  Jetzt Buchen
                </p>
              </button>
            </a>
          </div>

          {/* Right Section: Image + Overlay */}
          <div className="flex-1 relative">
            <img
              src={gold}
              alt="Oase Salon"
              className="w-full h-auto border-solid border-yellow-900 border-4 object-cover rounded-md shadow-lg"
            />

            {/* <div className="absolute bottom-4 left-4 bg-black/80 text-white px-6 py-4 rounded-md shadow-md flex items-center gap-8">
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-bold">
                  150+
                </span>
                <span className="text-sm md:text-base">Expert Care</span>
              </div>
              <div className="w-px h-10 bg-gray-500"></div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-bold">15</span>
                <span className="text-sm md:text-base">Trusted by Many</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Highlights;
